import fileSys from "./fileSystem";
const filePath = window.__main__.debug
  ? "/home/mw520/dea520/forced.json"
  : "/home/mw520/dea520/forced.json";
const snPath = "/home/mw520/dea520/dist/calib/device.json";
const certPath = window.__main__.debug
  ? fileSys.getUtilPath("license.dat")
  : "/home/mw520/dea520/license.dat";
const addonCrypto = getCryptoNode();
let forced = readFuncList();

// { "dryeyeHidden":false, "topographyHidden":false }
// 为特别版本的机器
export const { dryeyeHidden, topographyHidden, nibutInfrared } = forced;
// 读取磁盘序列号
// 由算法提供
export function readDiskSN() {}
// 读取出厂序列号

export function readFuncList() {
  let forced = fileSys.readJsonFile(filePath);
  if (forced) return forced;
  let result = fileSys.readJsonFile(snPath);
  if (!result) return { dryeyeHidden: false, topographyHidden: false };
  let sn = result.SN.trim();
  sn = result.SN.split("-")[0].trim();
  switch (sn) {
    case "DBD520":
      return { dryeyeHidden: false, topographyHidden: false };
    case "DBD520T":
      return { dryeyeHidden: true, topographyHidden: false };
    case "DBD520D":
      return { dryeyeHidden: false, topographyHidden: true };
    case "IBD520":
      return { dryeyeHidden: false, topographyHidden: false };
    case "IBD520T":
      return { dryeyeHidden: true, topographyHidden: false };
    case "IBD520D":
      return { dryeyeHidden: false, topographyHidden: true };
    default:
      return { dryeyeHidden: false, topographyHidden: false };
  }
}

// 获取解密后的功能
export function encrypto() {
  let funcs = decryptFile() || {
    topography: {
      enabled: true
    },
    dryeye: {
      enabled: true
    }
  };
  return funcs;
}

const decryptFile = function () {
  let obj;
  try {
    let txt = addonCrypto.DecryptFile(certPath);
    obj = JSON.parse(txt);
  } catch (error) {
    obj = { topography: {}, dryeye: {} };
  }
  return obj;
};
function getCryptoNode() {
  let addonCrypto;
  try {
    addonCrypto = window.require(fileSys.getUtilPath("MWCrypto.node"));
  } catch (error) {
    addonCrypto = null;
  }
  if (addonCrypto === null) {
    addonCrypto = {
      DecryptFile() {
        return '{"topography":{"enabled":true},"dryeye":{"enabled":true}}';
      },
      GenCert() {
        return null;
      }
    };
  }
  return addonCrypto;
}



// WEBPACK FOOTER //
// ./src/fileoprators/license.js